/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './AccountsPage.scss';

import { object, bool } from 'prop-types';
import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Store from 'state/Store';
import { filterAccountsGridAccountType } from 'state/account/AccountsGridFilteringActions';

import { getIsHistoricalBalancesLoading } from 'state/account/PositionsTableSelectors';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import AccountsGridDataProvider from 'components/shared/DataProviders/AccountsGridDataProvider';
import WorkplaceGridDataProvider from 'components/shared/DataProviders/WorkplaceGridDataProvider';

import AccountsGrid from 'components/layouts/Account/AccountsGrid';
import WorkplaceGrid from 'components/layouts/Account/WorkplaceGrid';
import Toaster from 'components/layouts/Toaster/Toaster';
import { getQueryParams } from 'state/session/SessionSelectors';
import { AccountsPageLoadingSkeleton } from 'components/layouts/LoadingSkeleton/LoadingSkeleton';
import { getHasReceivedPrimaryData } from 'state/requests/RequestStatusSelectors';
import TracRetailGrid from 'components/layouts/Account/TracRetailGrid';
import TracRetailGridDataProvider from 'components/shared/DataProviders/TracRetailGridDataProvider';
import {
  getHasRetailTracAccounts,
  getHasWorkPlaceRetirementAccounts,
  getHasOwnedCollegeSavingsOnly
} from 'state/account/AccountSelectors';

const AccountsGridWithData = AccountsGridDataProvider(AccountsGrid);
const WorkplaceGridWithData = WorkplaceGridDataProvider(WorkplaceGrid);
const SmallBusinessTracGridWithData = TracRetailGridDataProvider(TracRetailGrid)

export const AccountsPage = ({
  has529Only,
  hasWorkplaceRetirementAccounts,
  hasRetailTracAccounts,
  isHistoricalBalancesLoading,
  params,
  hasReceivedPrimaryData
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { accountType } = params;

  useEffect(() => {
    if (accountType) {
      Store.dispatch(filterAccountsGridAccountType(accountType));
    }
  }, [accountType]);

  useEffect(() => {
    if (isHistoricalBalancesLoading) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [isHistoricalBalancesLoading]);

  return (
    <Fragment>
      <AccountsPageLoadingSkeleton isActive={!hasReceivedPrimaryData} />
      {hasReceivedPrimaryData && (
        <Fragment>
          {(isHistoricalBalancesLoading || isLoading) && (
            <PageLoadingSpinner name="Historical Balances" />
          )}
          <div className="accounts-page">
            <Fragment>
              <AccountsGridWithData />
              {!has529Only && hasWorkplaceRetirementAccounts && (
                <WorkplaceGridWithData />
              )}
              {!has529Only && hasRetailTracAccounts && (
                <SmallBusinessTracGridWithData />
              )}
            </Fragment>
          </div>
          <Toaster />
        </Fragment>
      )}
    </Fragment>
  );
};

AccountsPage.propTypes = {
  allocations: object,
  hasCollegeSavingsOnly: bool
};

const mapStateToProps = (state) => {
  const { historicalBalances } = state;
  let historicalBalancesDate = '';
  if (historicalBalances) {
    historicalBalancesDate = historicalBalances.selectedDate;
  }
  return {
    isHistoricalBalancesLoading: getIsHistoricalBalancesLoading(state),
    has529Only: getHasOwnedCollegeSavingsOnly(state),
    hasRetailTracAccounts: getHasRetailTracAccounts(state),
    hasWorkplaceRetirementAccounts: getHasWorkPlaceRetirementAccounts(state),
    historicalBalancesDate,
    params: getQueryParams(state),
    hasReceivedPrimaryData: getHasReceivedPrimaryData(state)
  };
};

export default withRouter(connect(mapStateToProps)(AccountsPage));
